import { getEnrichedActivities } from "@/api/activities/client";
import { DEFAULT_PAGE_SIZE } from "@/shared/constants";
import { useInfiniteQuery } from "@tanstack/react-query";
import { flatten } from "lodash";
import { useMemo } from "react";
import { NftActivities } from "../../Nft/NftActivityDescription/types";

export function useActivities(
  queryKeyId: string = "all-activities",
  initiatorIds: string[] = [],
  activityTypes: NftActivities[] = [],
  collectionAddress: string | null = null,
) {
  const { data, isLoading, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: [queryKeyId, initiatorIds, activityTypes, collectionAddress],
    queryFn: async ({ pageParam = 0 }) => {
      return getEnrichedActivities(
        initiatorIds,
        activityTypes,
        collectionAddress,
        pageParam * DEFAULT_PAGE_SIZE,
        DEFAULT_PAGE_SIZE,
      );
    },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage || lastPage.length < DEFAULT_PAGE_SIZE) {
        return undefined;
      }

      return allPages.length;
    },
  });

  const activities = useMemo(() => {
    return data ? flatten(data.pages) : [];
  }, [data]);

  return { activities, isLoading, hasNextPage, fetchNextPage };
}
